"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _touchable = require("@react-x/touchable");

var _view = _interopRequireDefault(require("@react-x/view"));

var _Dropdown = _interopRequireDefault(require("../Dropdown"));

// Libraries
// Components
var TypeaheadInput = function TypeaheadInput(_ref) {
  var InputComponent = _ref.component,
      disabled = _ref.disabled,
      height = _ref.height,
      name = _ref.name,
      placeholder = _ref.placeholder,
      placeholderTextColor = _ref.placeholderTextColor,
      value = _ref.value,
      options = _ref.options,
      onChange = _ref.onChange,
      _onBlur = _ref.onBlur,
      renderOption = _ref.renderOption,
      style = _ref.style;
  return _react["default"].createElement(_Dropdown["default"], {
    trigger: function trigger(_ref2) {
      var handleOpen = _ref2.handleOpen,
          handleClose = _ref2.handleClose;
      return _react["default"].createElement(InputComponent, {
        autoComplete: 'off',
        disabled: disabled,
        name: name,
        placeholder: placeholder,
        defaultValue: value,
        onFocus: function onFocus(event) {
          return handleOpen();
        },
        onBlur: function onBlur(event) {
          var value = event.target.value;
          var option = {
            name: name,
            value: value
          };
          onChange(name, value, option);
          handleClose();
        }
      });
    },
    onBlur: function onBlur() {
      return _onBlur(name, true);
    },
    style: style
  }, function (_ref3) {
    var handleClose = _ref3.handleClose;
    return _react["default"].createElement(_Dropdown["default"].Content, {
      height: height,
      style: {
        width: '100%',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#E0E0EB',
        borderRadius: 4,
        boxShadow: '0 2px 5px rgba(194,194,194,0.5)'
      }
    }, _react["default"].createElement(_view["default"], {
      style: {
        paddingVertical: 8,
        backgroundColor: '#FFFFFF'
      }
    }, options.map(function (option, index) {
      return _react["default"].createElement(_view["default"], {
        key: index,
        style: {
          zIndex: 100
        }
      }, _react["default"].createElement(_touchable.TouchableOpacity, {
        onPress: function onPress() {
          onChange(name, option.value, option);
          handleClose();
        },
        children: renderOption(option)
      }));
    })));
  });
}; // --------------------------------------------------
// Props
// --------------------------------------------------


TypeaheadInput.propTypes = {
  height: _propTypes["default"].number
};
TypeaheadInput.defaultProps = {
  height: 300
};
var _default = TypeaheadInput;
exports["default"] = _default;